import { useEffect } from 'react';

//Importar socket.
import { getSocket } from '../config/socket'; 


const useSocketEvent = (event, callback) => {

  useEffect(() => {
    
    //console.log('voy a obtener el socket');
    
    //Obtener el socket del helper getSocket.
    let socket = getSocket();
    if (socket){

      socket.on(event, callback);
  
      return () => {
        socket.off(event, callback);
      };

    }

  }, [event, callback]);
};

export default useSocketEvent;
